import { images } from '../../constants';

const works = [
  {
    id: 1,
    name: 'Onisma UI',
    title: 'Onisma UI',
    description: 'Inventory management system can simplify the process of ordering and automating end-to-end production',
    imgUrl: images.onisma,
    projectLink: 'https://www.loom.com/share/655cd8a07dcb43209e500910d34e2705?sid=07d6be9e-a019-413c-8b7f-231b3e26c040',
    codeLink: '',
    tags: ['React JS', 'Redux'],
  },
  {
    id: 2,
    name: 'Change your world UI',
    title: 'Change your world UI',
    description: 'Aidez les pauvres dans le besoin Un monde rendu meilleur pour la contribution de tous',
    imgUrl: images.cyweb,
    projectLink: 'https://cyw-corporate-frontend-bbpe-git-add-logo-team-01-frontend.vercel.app/',
    codeLink: '',
    tags: ['React JS', 'Redux'],
  },
  {
    id: 3,
    name: 'Hagsyokingdom UI',
    title: 'Hagsyokingdom UI',
    description: '  Hagsyo Kingdom is dedicated to providing top-notch services to its customers',
    imgUrl: images.hagsyo,
    projectLink: 'https://cyw-corporate-frontend-bbpe-git-add-logo-team-01-frontend.vercel.app/',
    codeLink: '',
    tags: ['React JS', 'Redux'],
  },
  {
    id: 3,
    name: 'Neutral UI',
    title: 'Neutral UI',
    description: 'A full-service web development company dedicated to delivering custom and innovative solutions',
    imgUrl: images.neutralUI,
    projectLink: 'https://neutral.codes/',
    codeLink: '',
    tags: ['React JS', 'Redux'],
  },
  {
    id: 7,
    name: 'Covid metrics',
    title: 'Covid metric',
    description: 'provides the necessary information on covid 19 cases in any African country and their update',
    imgUrl: images.covid,
    projectLink: 'https://distracted-kirch-c847e7.netlify.app/',
    codeLink: 'https://github.com/joskalenda/metrics-webapp',
    tags: ['React JS', 'Redux'],
  },
  {
    id: 7,
    name: 'Onisma API',
    title: 'Onisma API',
    description: 'Inventory management API that can simplify the process of ordering and automating end-to-end production',
    imgUrl: images.onismaApi,
    projectLink: 'https://www.loom.com/share/803a1f7a1cce46b4b7e7149845ab0d21?sid=74bc4cd3-1420-404e-8410-60011d4c02b0',
    codeLink: '',
    tags: ['Rails API'],
  },
  {
    id: 8,
    name: 'Mover API',
    title: 'Mover API',
    description: 'Mover api is introduced to simplify your relocation process',
    imgUrl: images.moverApi,
    projectLink: 'https://loom.com/share/4b216eb5006b4d2096670157042f0c21?sid=adc2f1b8-80f9-4be8-a29b-72e4e227404c',
    codeLink: '',
    tags: ['Rails API'],
  },
  {
    id: 9,
    name: 'Change your world API',
    title: 'Change your world API',
    description: 'Aidez les pauvres dans le besoin Un monde rendu meilleur pour la contribution de tous',
    imgUrl: images.cywApi,
    projectLink: '',
    codeLink: '',
    tags: ['Rails API'],
  },
  {
    id: 11,
    name: 'TodoList',
    title: 'TodoList',
    description: 'A simple Application to schedule tasks, we build this awesome product with plaint ES6.and Webpack server.',
    imgUrl: images.todo,
    projectLink: 'https://joskalenda.github.io/to-do-list/dist/',
    codeLink: 'https://github.com/joskalenda/to-do-list',
    tags: ['ES6'],
  },
  {
    id: 4,
    name: 'Mabills tracker',
    title: 'Mabills tracker',
    description: 'Mabills tracker enables you to monitor how much of your budget has been spent over time',
    imgUrl: images.bills,
    projectLink: '',
    codeLink: 'https://github.com/joskalenda/budget-app',
    tags: ['Rails API'],
  },
  {
    id: 5,
    name: 'Vision technology',
    title: 'Vision technology',
    description: 'Talking about vision technologies that we are going to launch in the new few coming years,',
    imgUrl: images.vision,
    projectLink: 'https://practical-wright-2112a8.netlify.app/',
    codeLink: 'https://github.com/joskalenda/vision-technologies',
    tags: ['ES6'],
  },
  {
    id: 6,
    name: 'LeaderBoard',
    title: 'LeaderBoard',
    description: 'The leader board is a small website system built to display players score according to the high rate',
    imgUrl: images.board,
    projectLink: 'https://musing-almeida-aa50b4.netlify.app/',
    codeLink: 'https://github.com/joskalenda/leader-board',
    tags: ['ES6'],
  },
];

export default works;
